import { Navigate, useLocation, useParams } from "react-router-dom"

interface Props {
    to: string
    replace?: boolean
}

export function RouterRedirect(props: Props): JSX.Element {
    const location = useLocation()
    const hasParams = props.to.includes(":")
    const params = useParams()
    const search = location.search

    const pathname = hasParams && params
        ? Object.keys(params).reduce((acc, key) => {
              return acc.replace(`:${key}`, params[key] || "")
          }, props.to)
        : props.to

    const to = search ? { pathname, search } : pathname
    return <Navigate to={to} replace={props.replace} />
} 